import styled from 'styled-components';
import BREAKPOINTS from '@mlb/react-patterns/v4/style/breakpoints';

export const DesktopTeamWrapper = styled.div`
    @media (max-width: ${({breakpoint = BREAKPOINTS.sm}) => breakpoint}) {
        display: none;
    }
`;

export const MobileTeamWrapper = styled.div`
    display: none;
    
    @media (max-width: ${({breakpoint = BREAKPOINTS.sm}) => breakpoint}) {
        display: block;
    }
`;
